import { render, staticRenderFns } from "./AIThinking.vue?vue&type=template&id=5cc6b27e&scoped=true&"
import script from "./AIThinking.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIThinking.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AIThinking.vue?vue&type=style&index=0&id=5cc6b27e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6b27e",
  null
  
)

export default component.exports